import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import BreadcrumbNav from "../../../components/BreadcrumbNav";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import BannerSection from "../../../components/BannerSection";



const noticias = [
  {
    id: 1,
    images: [
      require('../../../assets/Not_23.jpeg'), 
      require('../../../assets/Not_24.jpeg'), 
      require('../../../assets/Not_25.jpeg'), 
      require('../../../assets/Not_27.jpeg'), 
      require('../../../assets/Not_31.jpeg'), 
      require('../../../assets/Not_32.jpeg'), 
      require('../../../assets/Not_33.jpeg'), 
      require('../../../assets/Not_34.jpeg'), 
      require('../../../assets/Not_35.jpeg'), 
      require('../../../assets/Not_36.jpeg'), 
      require('../../../assets/Not_37.jpeg'), 
      require('../../../assets/Not_39.jpeg'), 
      require('../../../assets/Not_40.jpeg'), 
      require('../../../assets/Not_41.jpeg'), 
    ],
    title: 'Encerramento do ano no ISPA Atlântida',
    subtitle: 'O Instituto Superior Politécnico Atlântida (ISPA) realizou, no dia 23 de Dezembro de 2025, uma cerimônia de encerramento do ano letivo repleta de celebrações e conquistas acadêmicas.',
    content: 'O Instituto Superior Politécnico Atlântida (ISPA) realizou, no dia 23 de Dezembro de 2025, uma cerimônia de encerramento do ano letivo repleta de celebrações e conquistas acadêmicas. A cerimônia foi marcada por momentos significativos, com a apresentação dos estudantes e a comemoração das conquistas acadêmicas.',
    content2: 'Através desta cerimônia, o ISPA reafirma seu compromisso com a excelência acadêmica e a formação de profissionais competentes. A instituição deseja aos seus estudantes um feliz ano novo e um futuro brilhante.\n\n',
    video: null
  },
  {
    id: 2,
    images: [
      require('../../../assets/Not_14.jpg'),
    ],
    title: 'Visita da comitiva do Instituto Nacional de Avaliação, Acreditação e Reconhecimento de Estudos do Ensino Superior – INAAREES',
    subtitle: 'Esta visita representa uma etapa importante para o fortalecimento da excelência acadêmica e do compromisso institucional do ISPA com a melhoria contínua dos seus cursos, assegurando padrões elevados de formação, investigação e impacto social.',
    content: 'O Instituto Superior Politécnico Atlântida recebeu, na manhã desta Segunda-feira, a comitiva do Instituto Nacional de Avaliação, Acreditação e Reconhecimento de Estudos do Ensino Superior – INAAREES, no âmbito do processo de avaliação e acreditação da qualidade do ensino superior.',
    content2: 'Esta visita representa uma etapa importante para o fortalecimento da excelência acadêmica e do compromisso institucional do ISPA com a melhoria contínua dos seus cursos, assegurando padrões elevados de formação, investigação e impacto social. O ISPA reafirma, assim, o seu propósito de contribuir para o desenvolvimento de Angola através de uma educação superior de qualidade, transparente e alinhada às exigências do sistema nacional de ensino superior.',
    date: 'Data: 29 de Outubro de 2025',
    video: null
  },
  {
    id: 3,
    images: [
      require('../../../assets/img-hero2.jpeg'),      

    ],
    title: 'Curso de Curta Duração: O Caminho Rápido para o Sucesso Profissional',
    subtitle: 'Descubra nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!',
    content: 'Aqui você vai aprender sobre os nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!',

    Link: '/portal-do-estudante/cursos-online',
    
    video: null
  },
  {
    id: 4,
    images: [
      require('../../../assets/Not_01.jpg'),
    ],
    title: 'Educação e Formação Científica',
    subtitle: 'A Pesquisa como Caminho para o Conhecimento',
    content: 'A Jornada Científica é um espaço dedicado à promoção do conhecimento, da investigação e da inovação. Nesta seção, os visitantes encontrarão informações completas sobre o evento, incluindo o tema central da edição, a programação das palestras, comunicações orais, apresentações de pôsteres, workshops e mesas-redondas.',
    content2: 'É também o lugar onde serão divulgadas as normas para submissão de trabalhos, as áreas temáticas contempladas, os nomes dos palestrantes convidados, além dos resultados e destaques dos melhores projetos apresentados.',
    video: null
  },
  {
    id: 5,
    images: [
      require('../../../assets/Not_02.jpg'),
    ],
    title: 'Formação de Qualidade para um Futuro Brilhante',
    subtitle: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação.',
    content: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação. Aqui, você encontra o suporte, o conhecimento e as ferramentas necessárias para alcançar grandes conquistas.',
    content2: 'Acreditamos que a educação é a chave para o sucesso e estamos comprometidos em oferecer uma formação de qualidade que prepare nossos alunos para um futuro brilhante. Junte-se a nós e descubra como podemos ajudar você a alcançar seus objetivos profissionais.',
    video: null
  },
  {
    id: 6,
    images: [
      require('../../../assets/Not_03.jpg'),
    ],
    title: 'O Seu Futuro Profissional Merece o Melhor',
    subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade.',
    content: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.',
    content2: 'Nossa missão é proporcionar uma educação de excelência, com professores qualificados e um ambiente de aprendizado inspirador. Venha fazer parte da nossa comunidade acadêmica e construa um futuro profissional promissor.',
    video: null
  },
  {
    id: 7,
    images: [
      require('../../../assets/Not_05.jpg'),
    ],
    title: 'Palestra  sobre a violencia Domestica',
    subtitle: 'Na palestra sobre a violência doméstica, especialistas e ativistas se reuniram para discutir esse tema crucial.',
    content: 'Na palestra sobre a violência doméstica, realizada em uma data não especificada, especialistas e ativistas se reuniram para discutir esse tema crucial. Durante o evento, foram abordadas questões como prevenção, suporte às vítimas e mudança de paradigmas culturais.',
    content2: 'A palestra contou com a participação de profissionais renomados, que compartilharam suas experiências e conhecimentos sobre o assunto. O objetivo foi sensibilizar a comunidade acadêmica e promover um diálogo construtivo sobre como combater essa problemática social.',
    video: null
  },
  {
    id: 8,
    images: [
      require('../../../assets/Not_06.jpg'),
    ],
    title: 'Lançamento da ROC- Revista Olhar Científico',
    subtitle: 'A Pesquisa como Caminho para o Conhecimento.',
    content: 'No lançamento da ROC - Revista Olhar Científico, um evento marcante ocorrido em uma data específica não fornecida, a comunidade acadêmica se reuniu para celebrar a inauguração desta importante plataforma de divulgação científica.',
    content2: 'A revista tem como objetivo promover a pesquisa e a inovação, oferecendo um espaço para a publicação de artigos científicos, estudos de caso e revisões de literatura. Durante o evento, foram apresentados os primeiros números da revista, destacando a qualidade e relevância dos trabalhos publicados.',
    video: null
  },
  {
    id: 9,
    images: [
      require('../../../assets/Not_08.jpg'),
    ],
    title: 'Batismo dos Caloiros ISPA 2023',
    subtitle: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição.',
    content: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição. O evento, realizado com entusiasmo pela comunidade acadêmica, incluiu rituais simbólicos e atividades de integração para dar as boas-vindas aos caloiros',
    content2: 'O batismo é uma tradição que visa fortalecer os laços entre os alunos e promover um senso de pertencimento à instituição. Durante a cerimônia, foram realizadas apresentações culturais, discursos inspiradores e momentos de confraternização, celebrando o início de uma nova jornada acadêmica.',
    video: null
  }
];

export default function NoticiaDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const noticia = noticias.find(n => n.id === parseInt(id));

  const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Comunicação' },
    { label: 'Notícias', href: '/comunicacao/noticias' },
    { label: noticia.title }
  ];

  if (!noticia) {
    return (
      <div style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff"
      }}>
        <div style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 8px 32px rgba(60,60,120,0.12)",
          padding: "48px 32px",
          textAlign: "center",
          animation: "fadeIn 1s"
        }}>
          {/* Animated page icon */}
          <svg
            width="80"
            height="80"
            viewBox="0 0 48 48"
            fill="none"
            style={{ marginBottom: 24, animation: "pageBounce 1.2s infinite" }}
          >
            <rect x="8" y="8" width="32" height="40" rx="6" fill="#6366f1" />
            <rect x="14" y="16" width="20" height="4" rx="2" fill="#fff" />
            <rect x="14" y="24" width="16" height="4" rx="2" fill="#e0e7ff" />
            <rect x="14" y="32" width="12" height="4" rx="2" fill="#e0e7ff" />
            <rect x="8" y="8" width="32" height="8" rx="4" fill="#0ea5e9" />
            <rect x="12" y="10" width="8" height="4" rx="2" fill="#fff" />
          </svg>
          <h2 style={{ marginBottom: 16, color: "#6366f1" }}>Notícia não encontrada</h2>
          <p style={{ marginBottom: 32, color: "#444" }}>
            Ops! A notícia que você procura não existe ou foi removida.<br />
            Volte para a página de notícias e explore outras novidades!
          </p>
          <Button
            variant="primary"
            size="lg"
            style={{
              borderRadius: "24px",
              padding: "12px 36px",
              fontWeight: 600,
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(99,102,241,0.12)"
            }}
            onClick={() => navigate("/comunicacao/noticias")}
          >
            ← Voltar para Notícias
          </Button>
        </div>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(40px);}
              to { opacity: 1; transform: translateY(0);}
            }
            @keyframes pageBounce {
              0%, 100% { transform: translateY(0);}
              50% { transform: translateY(-12px);}
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div>
      <BannerSection
          title="Notícias"
          subtitle="Acompanhe as últimas atualizações e eventos do ISPA Atlântida"
          description={`Bem-vindo à seção de notícias do ISPA Atlântida, onde você encontra as últimas atualizações, eventos e informações relevantes sobre nossa instituição. Fique por dentro das novidades e acompanhe nosso compromisso com a excelência acadêmica e a inovação.`}
          backgroundImage={require('../../../assets/img2.jpg')}
          backgroundId="instituition-Banner"
      />
       <BreadcrumbNav items={caminho} />

      <header id='header'>
        <AppHeader />
      </header>
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: "40px", marginTop: "40px" }}>
          <div style={{ flex: "1 1 350px", minWidth: 0 }}>
            <h2>{noticia.title}</h2>
            <h5 style={{ marginTop: "20px", color:'#000000' }}><b>{noticia.subtitle}</b></h5>
            <p style={{ marginTop: "10px" }}>{noticia.content}</p>
            <p style={{ marginTop: "10px" }}><b>{noticia.data}</b></p>
            <p style={{ marginTop: "10px" }}>{noticia.preco}</p>
            <p style={{ marginTop: "10px" }}>{noticia.Endereco}</p>
            <p style={{ marginTop: "10px" }}>{noticia.telefone}</p>
            <p style={{ marginTop: "10px" }}>{noticia.content2}</p>
            <p style={{ marginTop: "10px" }}>{noticia.content3}</p>
            <p style={{ marginTop: "20px", color:'#000000' }}><b>{noticia.date}</b></p>
            {noticia.link && (
              <p style={{ marginTop: "10px" }}>
                <b>Link para Inscrição:</b> <a href={noticia.link} target="_blank" rel="noopener noreferrer">{noticia.link}</a>
              </p>
            )}
            {noticia.video && (
              <p style={{ marginTop: "10px" }}>
                <b>Vídeo:</b> {noticia.video}
              </p>
            )}
          </div>
          <div style={{ flex: "0 1 600px", display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: "24px" }}>
            {noticia.video && (
              <video
                controls
                style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", marginBottom: noticia.images?.length ? "16px" : 0 }}
                src={noticia.video}
              >
                Seu navegador não suporta a reprodução de vídeo.
              </video>
            )}
            {noticia.images && noticia.images.length > 1 ? (
              <Carousel style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", overflow: "hidden" }}>
                {noticia.images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <Image src={img} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              noticia.images && noticia.images.length === 1 && (
                <Image src={noticia.images[0]} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
              )
            )}
          </div>
        </div>
      </Container>
      <AppLayout />
    </div>
  );
}
